module.exports = __webpack_public_path__ + "static/img/wenwangwen.8c02ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenwangwen.png
// module id = T3ty
// module chunks = 1